export const defaultNextButtonText = 'Empecemos!';
